// require("https://cdn.jsdelivr.net/npm/@mediapipe/camera_utils/camera_utils.js");
// require("https://cdn.jsdelivr.net/npm/@mediapipe/control_utils/control_utils.js");
// require("https://cdn.jsdelivr.net/npm/@mediapipe/drawing_utils/drawing_utils.js");
// require("https://cdn.jsdelivr.net/npm/@mediapipe/pose/pose.js")

import {Camera} from "@mediapipe/camera_utils/camera_utils.js";
import {drawConnectors, drawLandmarks} from "@mediapipe/drawing_utils/drawing_utils.js";
import {Pose, POSE_CONNECTIONS} from "@mediapipe/pose/pose.js";
import Vue from "vue";
import store from "./../store/index";
import { COLLECTION_FREQUENCY, POSE_FRAME_COUNT_PER_SECOND, IS_OVERLAP_TIME, POSE_DATA_FETCH_FROM_DB } from "@/utils/config";

/**
 * @deprecated
 * */
export default class BlazePose {

    constructor(eliteService, options = {}) {
        if (!eliteService) {
            throw new Error('Please pass in an instance of EliteService class');
        }
        this.eliteService = eliteService;
        const defaultOptions = {
            captureInterval: 1000,
            postAfterInterval: false,
            pauseVideoIfUserIsAway: false,
            pauseVideoCheckInterval: 5000,
            userInFrameCallback: null,
            callBackLoaded: null,
            stickFigureLineColor: null,
            modelComplexity: 0,
            minPoseConfidence: 0.1,
            minPartConfidence: 0.01,
            debug: false,
            renderer: {
                showVideo: true,
            }
        };
        this.options = Object.assign(defaultOptions, options);
        this.detectedPoses = [];//To collect the detected poses
        this.posesKeypoints = []
        this.pose = null
        this.camera = null

        this.oldAccuracy = 0;
        this.oldCalories = 0;
        this.timeLapsed = 0;

    }

    reset() {
        this.detectedPoses = [];
    }

    getLastDetectedPoses() {
        return this.posesKeypoints;
    }

    _roundTime(time) {
        return parseFloat(time).toFixed(3);
    }

    getSessionId() {
        return this.sessionId;
    }

    async _shouldCapture() {
        let time = await this.instructorVideoEl.getCurrentTime();
        let currentTime = this._roundTime(time);
        return this.isVideoPlaying && this._checkStepExists(currentTime);
    }

    _checkStepExists(currentTime) {
        return !!this.steps.find(step => currentTime >= +step.start && currentTime <= +step.end);
    }

    async createNewSession(EFTech, videoId = null) {
        if (!this.videoId) {
            this.videoId = videoId;
        }
        this.reset();
        if (this.sessionId) {
            await this.eliteService.updateSession(this.sessionId);
        }
        const { sessionId } = await this.eliteService.generateSession(this.videoId, EFTech);
        this.sessionId = sessionId;
        Vue.$log.info("session id ::: ", this.sessionId)
    }

    async initCamera(videoEl, canvasEl, instructorVideoEl, videoId, steps = [], EFTech) {
        await this.initBlazepose(videoEl, canvasEl, instructorVideoEl, videoId, steps, EFTech);
    }

    async initBlazepose(videoEl, canvasEl, instructorVideoEl, videoId, steps = [], EFTech) {
        this.videoEl = videoEl;
        this.videoId = videoId;
        this.canvasEl = canvasEl;

        if (!(videoEl || canvasEl || instructorVideoEl || videoId)) {
            throw Error("Please pass required parameters");
        }

        this.videoEl.height = this.videoEl.offsetHeight;
        this.videoEl.width = this.videoEl.offsetWidth;

        this.instructorVideoEl = instructorVideoEl;
        this.steps = steps
        this.isVideoPlaying = false;
        this.videoElement = this.videoEl;
        this.canvasElement = this.canvasEl;
        this.canvasCtx = this.canvasElement.getContext('2d')
        await this.createNewSession(EFTech);
        await this._setupListeners(this.instructorVideoEl);
        await this.startRendering()
        this._storePoses();

        if (this.options.pauseVideoIfUserIsAway) {
            this._checkUserMovementBP();
        }
    }

    async startRendering() {
       return new Promise ( async (resolve, reject) => {
        try {
            this.onResults = (results) => {
                try {
                    if (this.options.callBackLoaded && typeof this.options.callBackLoaded == 'function') {
                        this.options.callBackLoaded(true);
                        resolve(true);
                    }
                    this.drawImage(this.videoElement);
                    // Draw the overlays.
                    this.canvasCtx.save();
                    this.canvasCtx.clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
                    this.canvasCtx.drawImage(results.image, 0, 0, this.canvasEl.width, this.canvasEl.height);

                    this.canvasCtx.restore();

                    if (results.poseLandmarks) {
                        results.poseLandmarks.splice(0,11,{},{},{},{},{},{},{},{},{},{},{})
                    }
                    keypoints = results.poseLandmarks
                    this.posesKeypoints = keypoints
                    drawConnectors(this.canvasCtx, results.poseLandmarks, POSE_CONNECTIONS,
                                {visibilityMin: 0.65, color: this.options.stickFigureLineColor()});
                    drawLandmarks(this.canvasCtx, results.poseLandmarks,
                                {visibilityMin: 0.65, color: 'white', lineWidth: 3, radius: 3});
                    this.canvasCtx.restore();
                } catch (err) {
                    Vue.$log.error("blaze poser err ::: ", err)
                    reject(false)
                }
                
            }
            let keypoints = []
            this.pose = new Pose({locateFile: (file) => {
                // return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.3.1621277220/${file}`;
                // return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.1/${file}`;
                return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5.1675469404/${file}`;
            }});
            this.pose.setOptions({
                selfieMode: true,
                upperBodyOnly: false,
                smoothLandmarks: true,
                modelComplexity: this.options.modelComplexity,
                minDetectionConfidence: 0.5,
                minTrackingConfidence: 0.5
            });
            this.pose.onResults(this.onResults);
            this.camera = new Camera(this.videoElement, {
                onFrame: async () => {
                    await this.pose.send({image: this.videoElement});
                }
            });
           await this.camera.start();
        } catch (e) {
            Vue.$log.error("blaze pose error ::: ", e)
            reject(false)
        }
       })
    }

    async _storePoses() {
        var iterations = 0;
        var clusterPosesArray = [];
        let clusterPosesArrayForGetScoreAndAddPose = [];

        // To store the last pose data details if overlap time is true
        let lastPoseData = null;

        //calculating number of frames based on frames per second and the frequency
        let pose_data_count = COLLECTION_FREQUENCY * POSE_FRAME_COUNT_PER_SECOND;

        this.intervalID = setInterval(async () => {
            let pose = this.getLastDetectedPoses();
            const hasBPConfidence = this._isBodyVisible(pose);

            if (this.options.userInFrameCallback && typeof this.options.userInFrameCallback == 'function') {
                this.options.userInFrameCallback(hasBPConfidence);
            }
            if (await this._shouldCapture()) {
                if (pose === undefined) {
                    this.instructorVideoEl.pauseVideo();
                    this._setVideoPlaying(false);
                }

                iterations++;
                let time = await this.instructorVideoEl.getCurrentTime();
                
                const poseDetails = { time: this._roundTime(time), steps: { pose, width: this.videoEl.offsetWidth, height: this.videoEl.offsetHeight } };
                const modifiedPoseDetails = {...poseDetails, sessionId: this.sessionId, videoId: this.videoId, pose_by: 'BP'};
                if (this.options.debug) {
                    Vue.$log.info("BP keypoints :: ",poseDetails);
                }
                this.detectedPoses.push(poseDetails);
                clusterPosesArray.push(modifiedPoseDetails);
                clusterPosesArrayForGetScoreAndAddPose.push(modifiedPoseDetails);
                
                if(POSE_DATA_FETCH_FROM_DB !== "false" && !(iterations % (1000/this.options.captureInterval))) {
                    this.eliteService.postPoses(clusterPosesArray);
                    clusterPosesArray = [];
                }
                

                if(clusterPosesArrayForGetScoreAndAddPose.length >= pose_data_count && POSE_DATA_FETCH_FROM_DB === "false") {
                    let poseData = [];
                    if(IS_OVERLAP_TIME == 'true'){
                        if(lastPoseData){
                            //adding overlapping pose data object at the beginning of the pose data array
                            clusterPosesArrayForGetScoreAndAddPose.unshift(lastPoseData);
                        }
                        poseData = clusterPosesArrayForGetScoreAndAddPose.splice(0, pose_data_count);
                        //if overlap time is true then storing the last pose data details for next request
                        lastPoseData = poseData[poseData.length - 1];
                    }else{
                        poseData = clusterPosesArrayForGetScoreAndAddPose.splice(0, pose_data_count);
                    }
                    
                    this.eliteService.uploadPosesAndGetScore(poseData, this.oldAccuracy, this.oldCalories, this.timeLapsed)
                    .then(res => {
                        this.oldAccuracy = res.avgAccuracy;
                        this.oldCalories = res.calorieBurnt;
                        this.timeLapsed = res.validTotalTime;
                        store.dispatch('user/workout/uploadPosesAndGetScore', res);
                    })
                    .catch(err => {
                        // console.error(err);
                    })
                }
            }
        }, this.options.captureInterval);
    }

    dispose() {
        clearInterval(this.intervalID);
        if (this.poses) {
            this.poses.close();
        }

        if(this.videoEl && this.videoEl.srcObject){
          this.videoEl.srcObject.getTracks().forEach(function(track) {
            //stop camera
            track.stop();
          });
        }
    }

    async _setupListeners(instructorVideoEl) {
        if (!instructorVideoEl) {
            return;
        }
        instructorVideoEl.onloadedmetadata = (metadata) => {
        }

        instructorVideoEl.addEventListener("onStateChange", (event) => {
            switch (event.data) {
                case 1: this._setVideoPlaying(true);
                    return;
                case 0:
                case 2:
                case 3:
                case 5:
                    this._setVideoPlaying(false);
                    return;
            }
        });
    }

    _setVideoPlaying(playing) {
        this.isVideoPlaying = playing;
    }

    drawImage(image) {

        let width = image.offsetWidth;
        let height = image.offsetHeight;
        let cameraWidth = image.videoWidth;
        let cameraHeight = image.videoHeight;
        let aspectRatio = cameraWidth/cameraHeight;
        // The constant maintains the aspect ratio same as the video div
        // video div default aspect ratio is 538/426 or 1.385135135135135
        this.canvasEl.height = height;
        this.canvasEl.width = height*aspectRatio;
        // }
        /* Maintain image centered logic
        */
        // this.canvasCtx.clearRect(0, 0, width, height);
        // this.canvasCtx.save();
        // this.canvasCtx.scale(-1, 1);
        // this.canvasCtx.translate(-width, 0);
        // if (this.options.renderer.showVideo) {
        //     this.drawImageProp(this.canvasCtx, this.videoElement, 0, 0, this.canvasEl.width, this.canvasEl.height);
        // } else {
        //     this.canvasCtx.rect(0, 0, width, height);
        //     this.canvasCtx.fillStyle = "#000000";
        //     this.canvasCtx.fill();
        // }

        // this.canvasCtx.restore();

    }

    //https://stackoverflow.com/questions/21961839/simulation-background-size-cover-in-canvas
    drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {

        if (arguments.length === 2) {
            x = y = 0;
            w = this.canvasCtx.canvas.width;
            h = this.canvasCtx.canvas.height;
        }

        // default offset is center
        offsetX = typeof offsetX === "number" ? offsetX : 0.5;
        offsetY = typeof offsetY === "number" ? offsetY : 0.5;

        // keep bounds [0.0, 1.0]
        if (offsetX < 0) offsetX = 0;
        if (offsetY < 0) offsetY = 0;
        if (offsetX > 1) offsetX = 1;
        if (offsetY > 1) offsetY = 1;

        var iw = this.videoElement.videoWidth, //incoming image is a video , so taking the videoWidth instead of width
            ih = this.videoElement.videoHeight,//incoming image is a video , so taking the videoHeight instead of height
            r = Math.min(w / iw, h / ih),
            nw = iw * r,   // new prop. width
            nh = ih * r,   // new prop. height
            cx, cy, cw, ch, ar = 1;

        // decide which gap to fill    
        if (nw < w) ar = w / nw;
        if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
        nw *= ar;
        nh *= ar;

        // calc source rectangle
        cw = iw / (nw / w);
        ch = ih / (nh / h);

        cx = (iw - cw) * offsetX;
        cy = (ih - ch) * offsetY;

        // make sure source rectangle is valid
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cw > iw) cw = iw;
        if (ch > ih) ch = ih;

        // fill image in dest. rectangle
        this.canvasCtx.drawImage(this.videoElement, cx, cy, cw, ch, x, y, w, h);
    }

    _checkUserMovementBP() {
        this.intervalMovement = setInterval(() => {
            if (this.isVideoPlaying) {
                let poses = this.getLastDetectedPoses();
            }
        }, this.options.pauseVideoCheckInterval)
    }

    _isBodyVisible(pose) {
        let minPartConfidence = this.options.minPartConfidence;
        if (!pose) return;
        // 11=left_shoulder, 12=right_shoulder, 27=left_ankle, 28=right_ankle
        let points = [11, 12, 27, 28];
        let inFrameList = []
        inFrameList = points.map(element => {
            if (pose[element].x < 0 || pose[element].x > 1 || pose[element].y < 0 || pose[element].y > 1 || pose[element].visibility < minPartConfidence) {
                return false
            } else {
                return true
            }
        });
        return inFrameList.every(Boolean);
    }

}
